import { Banknote, Hourglass, Timer } from 'lucide-react';
import type { CarryStat } from './CarryStatStrip';
import {
  formatShare,
  formatUnits,
  unvestedUnits,
  vestedShare,
  type UnitCounts,
} from './carryFundValues';

// Still to be defined, on the admin side and the portal.
export const PAID_IN_STAT: CarryStat = {
  icon: Banknote,
  label: 'Paid in',
  value: '—',
};

export function vestingStats(counts: UnitCounts): CarryStat[] {
  return [
    {
      icon: Hourglass,
      label: 'Vested',
      value: formatUnits(counts.vested_units),
      hint: counts.units ? formatShare(vestedShare(counts)) : undefined,
    },
    {
      icon: Timer,
      label: 'Unvested',
      value: formatUnits(unvestedUnits(counts)),
    },
  ];
}
